import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { ApiResponse, MfoPapData } from '../../data/system/MfoPap';

@Injectable()
export class MfoPapService extends MfoPapData {

  constructor(private http: HttpClient) { super(); }

  get(param: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.mfo_pap_search}`;
    return this.http.post<ApiResponse>(host, param);
  }

}
